import { FC, ReactNode } from "react";
import { Button, ButtonProps, Stack } from "@mui/material";

interface FilterValueWithBatchInputActionsProps {
  onClose(): void;
  onSubmit(): void;
  disabled?: boolean;
  children?: ReactNode;
  variant: ButtonProps["variant"];
  submitLabel: string;
}

export const FilterValueWithBatchInputActions: FC<
  FilterValueWithBatchInputActionsProps
> = ({ variant, onClose, disabled, onSubmit, children, submitLabel }) => {
  return (
    <Stack direction="row" spacing={1} justifyContent="end" px={1}>
      <Button color="tertiary" onClick={onClose} size="small">
        Cancel
      </Button>

      <Button
        color="primary"
        size="small"
        variant={variant}
        onClick={onSubmit}
        disabled={disabled}
      >
        {submitLabel}
      </Button>

      {children}
    </Stack>
  );
};
